module.exports = __webpack_public_path__ + "packs/media/images/covid/covid_3-f97025c27c236d6a84e53b06c21548e7.png";